const globalStyles = {
  "@global": {
    body: {
      margin: 0,
    },
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: "Apercu, serif",
      fontWeight: 700,
    },
    h1: {
      fontSize: "calc(44px + 2vmin)",
    },
    p: {
      fontFamily: "WiredMono, sans-serif",
      fontSize: "18px",
      lineHeight: 1.4,
    },
  },
}

export const DURATION = "0.2s"
export const SECTION_MAX_WIDTH = "1140px"
export const MAX_WIDTH = "758px"
export const MOBILE_VIZ_TOP_PADDING = "calc(58px + 2rem)"

export const SCROLLY_TEXTBOX_OUTER_PADDING = {
  padding: "0 24px",
  "@media only screen and (max-width: 320px)": {
    padding: "0 16px",
  },
}

export const SCROLLY_TEXTBOX_INNER_PADDING = {
  padding: "24px 16px",
  "@media only screen and (max-width: 840px)": {
    padding: "16px",
  },
}

export default globalStyles
